import { TransferTypesPanel } from "@/components/organisms";
import { Nav } from "../VehicleCategories/VehicleCategories";
import { TransferTypesAdd } from "./TransferTypesAdd";
import { TransferTypesEdit } from "./TransferTypesEdit";

export const TransferTypes = () => {
  return (
    <>
      <Nav />
      <TransferTypesPanel />
    </>
  );
};

TransferTypes.Edit = TransferTypesEdit;
TransferTypes.Add = TransferTypesAdd;
